import { useContext } from "react";

import { AccountContext, type AccountContextValue } from "./context";

export function useAccount(): AccountContextValue {
  const context = useContext(AccountContext);
  if (context === null) {
    throw new Error("useAccount must be used inside AccountProvider");
  }
  return context;
}
